export default "__VITE_ASSET__1c3a446f__"